import { render, staticRenderFns } from "./NumberVerification.vue?vue&type=template&id=60a90b5e"
import script from "./NumberVerification.vue?vue&type=script&lang=js"
export * from "./NumberVerification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports